<section class="home-metrics modern-section dingo-section dingo-bg-base">
  <div class="container">
    <div class="row justify-content-center text-center mb-5">
      <div class="col-lg-8">
        <div class="home-section-head section-head reveal-on-scroll" data-reveal="section-head">
          <p class="home-section-kicker">Resultados en números</p>
          <h2 class="home-section-title">
            Resultados que respaldan <span class="highlight-green">nuestro impacto</span>
          </h2>
          <p class="home-section-desc">
            Experiencia, ejecución y crecimiento medible en múltiples industrias.
          </p>
          <div class="section-underline"></div>
        </div>
      </div>
    </div>
    <div #statsBlock class="home-metrics-grid reveal-on-scroll" data-reveal="card" style="--reveal-order: 2">
      @for (stat of stats; track stat.label; let i = $index) {
      <article class="home-metric-card">
        <div class="home-metric-value">{{ stat.suffix }}{{ currentValues[i] }}</div>
        <div class="home-metric-label">{{ stat.label }}</div>
      </article>
      }
    </div>
  </div>
</section>
